import React, { useState } from "react";
import { edit_icon } from "../assets/imgs";
import { post } from "../Services/ApiHandler";
import { toast } from "react-toastify";
import { URL } from "../Services/Constant";
import { useLocation } from "react-router-dom";

const MultiSelectCheckboxSeverity = ({
  data,
  selected,
  setSelected,
  disable,
  setAlertData,
  site_id,
  selectAlertTypes,
}) => {
  const [editIndex, setEditIndex] = useState(null);
  const [tempSeverity, setTempSeverity] = useState("");

  const { pathname } = useLocation();
  const user = JSON.parse(localStorage.getItem("user_details") ?? "{}");
  const permission = JSON.parse(
    localStorage.getItem("user_permission") ?? "[]",
  );

  const companyAddAllowed =
    (permission?.includes("CAN-Add-KNF_COMPANY_CAMERA") &&
      pathname == "/company-alert-types") ||
    (permission?.includes("CAN-Add-KNF_COMPANY_CAMERA") &&
      pathname == "/company-sites-view") ||
    pathname == "/site-alert-types";
  const companyEditAllowed =
    (permission?.includes("CAN-Edit-KNF_COMPANY_CAMERA") &&
      pathname == "/company-alert-types") ||
    (permission?.includes("CAN-Edit-KNF_COMPANY_CAMERA") &&
      pathname == "/company-sites-view") ||
    pathname == "/site-alert-types";

  const handleSelect = (id) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id],
    );
  };

  const handleSelectAll = () => {
    const ids = data.map((item) => item?.id);

    setSelected((prev) => (prev.length === ids.length ? [] : ids));
  };

  const handleChange = (e) => {
    const value = e.target.value;

    if (["1", "2", "3", ""].includes(value)) {
      setTempSeverity(value);
    }
  };

  // const handleSave = async (index, item) => {
  //   await selectAlertTypes();
  //   let formdata = new FormData();

  //   formdata.append(
  //     "knf_company_site_id",
  //     site_id ?? user?.knf_company_site_id,
  //   );
  //   formdata.append("severity", tempSeverity);
  //   formdata.append("name", item?.name);

  //   post(URL.SITE_ALERT_TYPES_UPDATE, formdata)
  //     .then((res) => {
  //       if (res?.status === "success") {
  //         // toast.success(res?.message);
  //         setEditIndex(null);

  //         setAlertData((prev) => {
  //           const updated = [...prev];

  //           updated[index].severity = tempSeverity || updated[index].severity;

  //           return updated;
  //         });

  //         setTempSeverity("");
  //       }
  //     })
  //     .catch((err) => {
  //       console.log("err", err);
  //     });
  // };

  const handleSave = async (index, item) => {
    // if alert not selected, select first
    if (!selected.includes(item?.id)) {
      toast.error("Please select alert type");
      return;
    }

    // save selected alerts first
    const saveAlertType = await selectAlertTypes();

    if (!saveAlertType) {
      return;
    }

    let formdata = new FormData();

    formdata.append(
      "knf_company_site_id",
      site_id ?? user?.knf_company_site_id,
    );

    formdata.append("severity", tempSeverity);
    formdata.append("name", item?.name);

    post(URL.SITE_ALERT_TYPES_UPDATE, formdata)
      .then((res) => {
        if (res?.status === "success") {
          setEditIndex(null);

          setAlertData((prev) => {
            const updated = [...prev];

            updated[index].severity = tempSeverity || updated[index].severity;

            return updated;
          });
        }
        setEditIndex(null);
        setTempSeverity("");
      })
      .catch((err) => {
        console.log("err", err);
        setEditIndex(null);
        setTempSeverity("");
      });
  };

  const handleCancel = () => {
    setEditIndex(null);
    setTempSeverity("");
  };

  return (
    <div className="multi-select-container">
      <div className="d-flex ac-jb mb-3 pe-5">
        {/* <select className="form-select p-2" style={{ width: "200px" }}>
          <option hidden value="">
            Select Items
          </option>
        </select> */}

        <p className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mb-0 text-nowrap ps-3">
          Alert List
        </p>
        <p className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mb-0 text-nowrap">
          Severity
        </p>
      </div>
      {companyAddAllowed && (
        <div className="d-flex ac-je mb-4 pe-4">
          <button className="select-btnt ms-4" onClick={handleSelectAll}>
            {selected?.length === data?.length ? "Unselect All" : "Select All"}
          </button>
        </div>
      )}

      {data?.length == 0 && (
        <div className="card shadow-sm border-0 rounded-4 mt-5">
          <div className="card-body text-center py-5">
            <div className="mb-3">
              <div className="bg-light rounded-circle d-inline-flex p-4">
                <i className="bi bi-bell-fill fs-1 text-muted"></i>
              </div>
            </div>
            <h5 className="text-muted mb-2">No Alert Types</h5>
            <p className="text-muted small mb-0">No data found</p>
          </div>
        </div>
      )}

      <div className="checkbox-list px-3">
        {data?.map((item, ind) => {
          const isEditing = editIndex === ind;

          return (
            <div
              key={ind}
              className="d-flex align-items-center justify-content-between gap-2 mb-3"
            >
              <label
                className="d-flex align-items-center gap-2 col-md-10"
                style={{ cursor: "pointer" }}
              >
                <input
                  type="checkbox"
                  checked={selected.includes(item?.id)}
                  onChange={() => handleSelect(item?.id)}
                  style={{
                    width: "18px",
                    height: "18px",
                    borderRadius: "50%",
                    accentColor: "#852e59",
                  }}
                />

                <span className="f4">{item?.name}</span>
              </label>

              <div className="d-flex align-items-center gap-2">
                {/* severity input */}
                <input
                  className="input-box text-center f4"
                  style={{
                    width: "60px",
                    height: "35px",
                  }}
                  type="text"
                  value={isEditing ? tempSeverity : item?.severity || ""}
                  onChange={(e) => isEditing && handleChange(e)}
                  disabled={!isEditing}
                />

                {/* action buttons */}
                {isEditing ? (
                  <>
                    <button
                      onClick={() => handleSave(ind, item)}
                      className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white add-btn "
                    >
                      Save
                    </button>

                    <button
                      onClick={handleCancel}
                      className=" f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 add-btn"
                      style={{
                        color: "black",
                        background: "#fdcb0a",
                      }}
                    >
                      Cancel
                    </button>
                  </>
                ) : (
                  <>
                    {[
                      "/company-sites-view",
                      "/company-alert-types",
                      "/site-alert-types",
                    ].includes(pathname) && (
                      <>
                        {companyEditAllowed && (
                          <button
                            className="cust-btn"
                            onClick={() => {
                              setEditIndex(ind);
                              setTempSeverity(item?.severity?.toString() || "");
                            }}
                            disabled={!selected.includes(item?.id)}
                          >
                            <img src={edit_icon} alt="" className="edit-btn" />
                          </button>
                        )}
                      </>
                    )}
                  </>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MultiSelectCheckboxSeverity;
